import { Guides } from "./components/guides.js";
import { HeroPhysics } from "./components/hero-physics.js";
import { HeroTransformation } from "./components/hero-transformation.js";
import { HeroArcs } from "./components/hero-arcs.js";

/* -------------------------------------------------- */
/* 🙂 General */
/* -------------------------------------------------- */

const isReducedMotion = window.matchMedia(
	"(prefers-reduced-motion: reduce)"
).matches;

/* -------------------------------------------------- */
/* 📏 Guides */
/* -------------------------------------------------- */

new Guides();

/* -------------------------------------------------- */
/* 🎨 Hero Animation */
/* -------------------------------------------------- */

// Animation registry - add new animations here
const heroAnimations = {
	profil: HeroPhysics,
	transformation: HeroTransformation,
	arcs: HeroArcs,
};

const heroCanvas = document.querySelector("[data-hero-animation]");
if (heroCanvas && !isReducedMotion) {
	const type = heroCanvas.dataset.heroAnimation;
	const AnimationClass = heroAnimations[type];
	if (AnimationClass) new AnimationClass(heroCanvas);
}
